module.exports = __webpack_public_path__ + "img/1920px-Balkenkreuz_underwing.svg.45e37467.png";